/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const splitOnMiddleDot = <Whole extends `${string} \u00b7 ${string}`>(
  whole: Whole
): Whole extends `${infer Start} \u00b7 ${infer End}` ? [Start, End] : [string, string] =>
  // @ts-expect-error TypeScript only sees a `string[]` as the return type of `.split()`, not a tuple
  whole.split(' · ')
